var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Chip',{key:_vm.iconName,staticClass:"suaw-chip--clickable",attrs:{"size":_vm.size,"chip-type":"icon","status":"critical","icon":_vm.iconName,"shape":"square","label":_vm.likeLabel},on:{"click":_vm.handleLikeClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }